(function () {
  'use strict';

  var QUESTIONS = [
    {
      key: 'frequency',
      title: 'How often do you wear contact lenses?',
      help: 'Your wear pattern helps us balance convenience, comfort, and value.',
      options: [
        { value: 'every-day', label: 'Every day' },
        { value: 'few-times', label: 'A few times a week' },
        { value: 'occasional', label: 'Only occasionally' },
      ],
    },
    {
      key: 'priority',
      title: 'What matters most during a typical day?',
      help: 'Choose the benefit you would notice most when wearing your lenses.',
      options: [
        { value: 'comfort', label: 'All-day comfort' },
        { value: 'screens', label: 'Comfort during screen-heavy days' },
        { value: 'value', label: 'Keeping the cost down' },
        { value: 'handling', label: 'A simple, low-maintenance routine' },
      ],
    },
    {
      key: 'astigmatism',
      title: 'Does your contact lens prescription mention CYL and AXIS?',
      help: 'CYL and AXIS usually mean your prescription needs a toric lens for astigmatism.',
      options: [
        { value: 'yes', label: 'Yes, it shows CYL and AXIS' },
        { value: 'no', label: 'No, it only shows SPH' },
        { value: 'not-sure', label: "I'm not sure" },
      ],
    },
    {
      key: 'reading',
      title: 'Does your prescription include an ADD value?',
      help: 'An ADD value usually means you need near and distance support from a multifocal lens.',
      options: [
        { value: 'yes', label: 'Yes, it includes ADD' },
        { value: 'no', label: 'No, it is distance only' },
        { value: 'not-sure', label: "I'm not sure" },
      ],
    },
    {
      key: 'routine',
      title: 'Which lens routine fits your life best?',
      help: 'This preference helps us rank daily and reusable options within your prescription type.',
      options: [
        { value: 'daily-routine', label: 'A fresh pair every wear, with no cleaning' },
        { value: 'reusable-routine', label: 'Reuse lenses and clean them each night' },
        { value: 'flexible', label: 'I am open to either routine' },
      ],
    },
  ];

  var LABELS = {
    spherical: 'Standard single-vision',
    toric: 'Toric',
    multifocal: 'Multifocal',
    'toric-multifocal': 'Toric multifocal',
    daily: 'Daily disposable',
    'two-weekly': 'Two-weekly',
    monthly: 'Monthly',
    comfort: 'all-day comfort',
    screens: 'screen-heavy days',
    value: 'value',
    handling: 'a simple routine',
    'daily-routine': 'with a fresh daily pair',
    'reusable-routine': 'with a reusable lens routine',
    flexible: 'across daily and reusable options',
  };

  function emit(eventName, detail) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, detail || {}));
  }

  function formatMoney(value) {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
      minimumFractionDigits: 2,
    }).format(value);
  }

  function requiresPrescription(product) {
    if (product.profile && product.profile.eligible) return true;

    var productType = String(product.productType || '').toLowerCase();
    return productType.indexOf('contact lens') !== -1
      || productType.indexOf('disposable') !== -1
      || productType.indexOf('toric') !== -1;
  }

  function productDestination(product, purchaseMode) {
    var destination = new URL(product.url, window.location.origin);
    if (requiresPrescription(product)) {
      var resolvedPurchaseMode = purchaseMode === 'once' || !product.hasSubscription ? 'once' : 'subscription';
      destination.searchParams.set('purchase', resolvedPurchaseMode);
      if (product.variantId) destination.searchParams.set('variant', product.variantId);
    }
    return destination.pathname + destination.search;
  }

  function initQuiz(root) {
    if (root.dataset.qeQuizReady === 'true') return;

    var dialog = root.querySelector('[data-qe-quiz-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    root.dataset.qeQuizReady = 'true';

    var ui = {
      dialog: dialog,
      close: dialog.querySelector('[data-qe-quiz-close]'),
      progress: dialog.querySelector('[data-qe-quiz-progress]'),
      step: dialog.querySelector('[data-qe-quiz-step]'),
      questionView: dialog.querySelector('[data-qe-quiz-question-view]'),
      questionTitle: dialog.querySelector('[data-qe-quiz-question]'),
      questionHelp: dialog.querySelector('[data-qe-quiz-help]'),
      options: dialog.querySelector('[data-qe-quiz-options]'),
      guidanceView: dialog.querySelector('[data-qe-quiz-guidance-view]'),
      loadingView: dialog.querySelector('[data-qe-quiz-loading-view]'),
      resultView: dialog.querySelector('[data-qe-quiz-result-view]'),
      resultTitle: dialog.querySelector('[data-qe-quiz-result-title]'),
      resultSummary: dialog.querySelector('[data-qe-quiz-result-summary]'),
      resultGrid: dialog.querySelector('[data-qe-quiz-result-grid]'),
      resultEmpty: dialog.querySelector('[data-qe-quiz-result-empty]'),
      browseLinks: dialog.querySelectorAll('[data-qe-quiz-browse]'),
      back: dialog.querySelector('[data-qe-quiz-back]'),
      restart: dialog.querySelector('[data-qe-quiz-restart]'),
    };

    var state = {
      answers: {},
      currentStep: 0,
      view: 'question',
      products: null,
      productsPromise: null,
    };

    function reset() {
      state.answers = {};
      state.currentStep = 0;
      state.view = 'question';
    }

    function hideViews() {
      [ui.questionView, ui.guidanceView, ui.loadingView, ui.resultView].forEach(function (view) {
        if (view) view.hidden = true;
      });
    }

    function focusHeading(element) {
      window.requestAnimationFrame(function () {
        if (element) element.focus({ preventScroll: true });
      });
    }

    function updateNavigation() {
      var atStart = state.view === 'question' && state.currentStep === 0;
      ui.back.hidden = atStart;
      ui.restart.hidden = state.view !== 'result' && state.view !== 'guidance';
    }

    function updateHeader(label, progress) {
      ui.step.textContent = label;
      ui.progress.style.width = progress + '%';
    }

    function renderQuestion(index) {
      var question = QUESTIONS[index];
      state.currentStep = index;
      state.view = 'question';
      hideViews();
      ui.questionView.hidden = false;
      ui.questionTitle.textContent = question.title;
      ui.questionHelp.textContent = question.help;
      ui.options.replaceChildren();

      question.options.forEach(function (option) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'qe-quiz-option';
        button.textContent = option.label;
        button.dataset.value = option.value;
        button.addEventListener('click', function () {
          chooseAnswer(question, option);
        });
        ui.options.appendChild(button);
      });

      updateHeader('Question ' + (index + 1) + ' of ' + QUESTIONS.length, Math.round((index / QUESTIONS.length) * 100));
      updateNavigation();
      focusHeading(ui.questionTitle);
    }

    function deriveCorrection() {
      if (state.answers.astigmatism === 'not-sure' || state.answers.reading === 'not-sure') return null;
      if (state.answers.astigmatism === 'yes' && state.answers.reading === 'yes') return 'toric-multifocal';
      if (state.answers.astigmatism === 'yes') return 'toric';
      if (state.answers.reading === 'yes') return 'multifocal';
      return 'spherical';
    }

    function chooseAnswer(question, option) {
      state.answers[question.key] = option.value;
      emit('qe_quiz_answer', {
        quiz_step: state.currentStep + 1,
        answer_key: question.key,
        answer_value: option.value,
      });

      if (state.currentStep < QUESTIONS.length - 1) {
        renderQuestion(state.currentStep + 1);
        return;
      }

      if (!deriveCorrection()) {
        renderGuidance();
        return;
      }

      renderGuidedResults();
    }

    function loadProducts() {
      if (state.products) return Promise.resolve(state.products);
      if (state.productsPromise) return state.productsPromise;

      state.productsPromise = fetch(dialog.dataset.productsUrl, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Catalogue request failed');
          return response.json();
        })
        .then(function (payload) {
          var profiles = window.QEQuizProductProfiles || {};
          state.products = (payload.products || [])
            .map(function (product) {
              var availableVariants = (product.variants || []).filter(function (variant) {
                return variant.available;
              });
              var prices = availableVariants.map(function (variant) {
                return Number(variant.price);
              });

              return {
                title: product.title,
                handle: product.handle,
                vendor: product.vendor,
                productType: product.product_type,
                url: '/products/' + product.handle,
                image: product.images && product.images[0] ? product.images[0].src : '',
                available: availableVariants.length > 0,
                variantId: availableVariants.length ? availableVariants[0].id : '',
                price: prices.length ? Math.min.apply(Math, prices) : null,
                profile: profiles[product.handle] || null,
              };
            })
            .filter(function (product) {
              return product.available;
            });
          return state.products;
        })
        .catch(function (error) {
          state.productsPromise = null;
          throw error;
        });

      return state.productsPromise;
    }

    function loadPurchaseDetails(product) {
      product.hasSubscription = false;

      return fetch(product.url + '.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Product purchase options request failed');
          return response.json();
        })
        .then(function (payload) {
          var variant = (payload.variants || []).find(function (item) {
            return String(item.id) === String(product.variantId);
          }) || (payload.variants || [])[0];

          if (!variant) return product;

          product.oneTimePrice = Number(variant.price) / 100;

          var allocation = (variant.selling_plan_allocations || [])[0];
          if (!allocation) return product;

          product.hasSubscription = true;

          var sellingPlans = [];
          (payload.selling_plan_groups || []).forEach(function (group) {
            sellingPlans = sellingPlans.concat(group.selling_plans || []);
          });
          var plan = sellingPlans.find(function (item) {
            return String(item.id) === String(allocation.selling_plan_id);
          });
          var adjustment = plan && plan.price_adjustments ? plan.price_adjustments[0] : null;

          product.subscriptionPrice = Number(allocation.price) / 100;
          product.subscriptionFrequency = plan && plan.options && plan.options[0]
            ? plan.options[0].value
            : plan && plan.name
              ? plan.name
              : 'Subscription delivery';
          product.subscriptionSaving = adjustment && adjustment.value_type === 'percentage'
            ? Number(adjustment.value)
            : null;

          return product;
        })
        .catch(function () {
          return product;
        });
    }

    function renderGuidance() {
      state.view = 'guidance';
      hideViews();
      ui.guidanceView.hidden = false;
      updateHeader('Your safest next step', 100);
      updateNavigation();
      focusHeading(ui.guidanceView.querySelector('h3'));
      emit('qe_quiz_guidance_view', { reason: 'prescription_unsure' });
    }

    function scoreProduct(product) {
      var profile = product.profile;
      var score = 0;
      var frequency = state.answers.frequency;
      var priority = state.answers.priority;
      var routine = state.answers.routine;

      if (frequency === 'occasional') {
        if (profile.schedule === 'daily') score += 30;
      } else if (frequency === 'few-times') {
        if (profile.schedule === 'daily') score += 22;
        if (profile.schedule === 'two-weekly') score += 10;
      } else if (frequency === 'every-day') {
        if (profile.schedule === 'monthly') score += 25;
        if (profile.schedule === 'two-weekly') score += 20;
        if (profile.schedule === 'daily') score += 10;
      }

      if (routine === 'daily-routine') {
        score += profile.schedule === 'daily' ? 35 : -10;
      } else if (routine === 'reusable-routine') {
        if (profile.schedule === 'monthly') score += 30;
        if (profile.schedule === 'two-weekly') score += 25;
        if (profile.schedule === 'daily') score -= 5;
      }

      if (profile.priorities.indexOf(priority) !== -1) score += 35;
      if (priority === 'value') {
        if (profile.tier === 'value') score += 40;
        if (profile.schedule === 'monthly') score += 10;
      }
      if (priority === 'comfort' && profile.tier === 'premium') score += 12;
      if (priority === 'screens' && profile.priorities.indexOf('screens') !== -1) score += 15;
      if (priority === 'handling' && profile.schedule === 'daily') score += 15;
      if (profile.tier === 'standard') score += 4;

      return score;
    }

    function chooseDiverseProducts(products) {
      var selected = [];
      var vendors = {};

      products.forEach(function (product) {
        if (selected.length >= 2 || vendors[product.vendor]) return;
        selected.push(product);
        vendors[product.vendor] = true;
      });

      products.forEach(function (product) {
        if (selected.length >= 2 || selected.indexOf(product) !== -1) return;
        selected.push(product);
      });

      return selected;
    }

    function renderGuidedResults() {
      state.view = 'loading';
      hideViews();
      ui.loadingView.hidden = false;
      updateHeader('Matching the current range', 100);
      updateNavigation();

      loadProducts()
        .then(function (products) {
          var correction = deriveCorrection();
          var matches = products
            .filter(function (product) {
              return product.available && product.profile && product.profile.eligible && product.profile.correction === correction;
            })
            .map(function (product) {
              product.quizScore = scoreProduct(product);
              return product;
            })
            .sort(function (a, b) {
              if (b.quizScore !== a.quizScore) return b.quizScore - a.quizScore;
              if (a.price === null) return 1;
              if (b.price === null) return -1;
              return a.price - b.price;
            });

          return Promise.all(chooseDiverseProducts(matches).map(loadPurchaseDetails));
        })
        .then(function (products) {
          renderResults(products);
        })
        .catch(function () {
          renderResults([], true);
        });
    }

    function createProductCard(product, index) {
      var article = document.createElement('article');
      article.className = 'qe-quiz-pick';

      var media = document.createElement('a');
      media.className = 'qe-quiz-pick__media';
      media.href = productDestination(product);
      if (product.image) {
        var image = document.createElement('img');
        image.src = product.image;
        image.alt = product.title;
        image.loading = 'lazy';
        media.appendChild(image);
      } else {
        var imageFallback = document.createElement('span');
        imageFallback.textContent = 'View product';
        media.appendChild(imageFallback);
      }

      var badge = document.createElement('span');
      badge.className = 'qe-quiz-pick__badge';
      badge.textContent = index === 0 ? 'Top catalogue match' : 'Also consider';
      media.appendChild(badge);

      var body = document.createElement('div');
      body.className = 'qe-quiz-pick__body';
      var title = document.createElement('h4');
      title.textContent = product.title;
      var meta = document.createElement('p');
      meta.textContent = LABELS[product.profile.correction] + ' | ' + LABELS[product.profile.schedule];
      var price = document.createElement('strong');
      price.className = 'qe-quiz-pick__price';
      price.textContent = product.price !== null ? 'From ' + formatMoney(product.price) : 'View current price';
      var link = document.createElement('a');
      link.className = 'qe-quiz-pick__cta';
      link.textContent = requiresPrescription(product) ? 'Choose prescription' : 'View product';
      link.addEventListener('click', function () {
        emit('qe_quiz_product_click', { product_handle: product.handle, result_position: index + 1, result_mode: 'guided' });
      });

      if (requiresPrescription(product) && product.hasSubscription) {
        var purchaseLabel = document.createElement('p');
        purchaseLabel.className = 'qe-quiz-pick__purchase-label';
        purchaseLabel.textContent = 'Purchase options';

        var purchaseOptions = document.createElement('div');
        purchaseOptions.className = 'qe-quiz-pick__purchase-options';
        purchaseOptions.setAttribute('role', 'group');
        purchaseOptions.setAttribute('aria-label', 'Purchase option for ' + product.title);

        var purchaseButtons = [];
        var selectedPurchase = 'subscription';

        function updatePurchaseOption(purchaseMode) {
          selectedPurchase = purchaseMode;
          var destination = productDestination(product, selectedPurchase);
          var selectedPrice = selectedPurchase === 'once' ? oneTimePrice : subscriptionPrice;
          media.href = destination;
          link.href = destination;
          price.textContent = selectedPrice !== null && selectedPrice !== undefined
            ? formatMoney(selectedPrice)
            : 'View current price';

          purchaseButtons.forEach(function (button) {
            var isSelected = button.dataset.purchaseMode === selectedPurchase;
            button.classList.toggle('is-active', isSelected);
            button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
          });
        }

        var oneTimePrice = product.oneTimePrice !== undefined ? product.oneTimePrice : product.price;
        var subscriptionPrice = product.subscriptionPrice !== undefined ? product.subscriptionPrice : oneTimePrice;

        [
          { value: 'once', label: 'One-time purchase', price: oneTimePrice },
          {
            value: 'subscription',
            label: 'Subscribe & Save',
            price: subscriptionPrice,
            comparePrice: oneTimePrice,
            frequency: product.subscriptionFrequency,
            saving: product.subscriptionSaving,
          },
        ].forEach(function (option) {
          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'qe-quiz-pick__purchase-option';
          button.dataset.purchaseMode = option.value;

          if (option.saving) {
            var saving = document.createElement('span');
            saving.className = 'qe-quiz-pick__purchase-saving';
            saving.textContent = 'Save ' + option.saving + '%';
            button.appendChild(saving);
          }

          var optionTop = document.createElement('span');
          optionTop.className = 'qe-quiz-pick__purchase-top';
          var optionName = document.createElement('strong');
          optionName.textContent = option.label;
          var optionPrice = document.createElement('span');
          optionPrice.className = 'qe-quiz-pick__purchase-price';

          if (option.comparePrice && option.price !== option.comparePrice) {
            var optionWas = document.createElement('s');
            optionWas.textContent = formatMoney(option.comparePrice);
            optionPrice.appendChild(optionWas);
          }

          var optionNow = document.createElement('strong');
          optionNow.textContent = option.price !== null ? formatMoney(option.price) : 'View price';
          optionPrice.appendChild(optionNow);
          optionTop.append(optionName, optionPrice);
          button.appendChild(optionTop);

          if (option.value === 'subscription' && option.frequency) {
            var delivery = document.createElement('span');
            delivery.className = 'qe-quiz-pick__purchase-delivery';
            var deliveryLabel = document.createElement('span');
            deliveryLabel.textContent = 'Deliver every';
            var deliveryFrequency = document.createElement('strong');
            deliveryFrequency.textContent = option.frequency;
            delivery.append(deliveryLabel, deliveryFrequency);
            button.appendChild(delivery);
          }

          button.addEventListener('click', function () {
            updatePurchaseOption(option.value);
            emit('qe_quiz_purchase_option', {
              product_handle: product.handle,
              purchase_mode: option.value,
              result_position: index + 1,
            });
          });
          purchaseButtons.push(button);
          purchaseOptions.appendChild(button);
        });

        var subscriptionGuide = document.createElement('a');
        subscriptionGuide.className = 'qe-quiz-pick__subscription-guide';
        subscriptionGuide.href = '/pages/subscription-details';
        subscriptionGuide.target = '_blank';
        subscriptionGuide.rel = 'noopener';
        subscriptionGuide.textContent = 'How subscriptions work';

        updatePurchaseOption(selectedPurchase);
        body.append(title, meta, price, purchaseLabel, purchaseOptions, subscriptionGuide, link);
      } else {
        media.href = productDestination(product);
        link.href = productDestination(product);
        body.append(title, meta, price, link);
      }

      article.append(media, body);
      return article;
    }

    function renderResults(products, loadFailed) {
      var correction = deriveCorrection();
      state.view = 'result';
      hideViews();
      ui.resultView.hidden = false;
      ui.resultGrid.replaceChildren();
      ui.resultEmpty.hidden = products.length > 0;
      ui.resultTitle.textContent = products.length ? 'Your Quality Eyes shortlist' : 'No catalogue match found';
      ui.resultSummary.textContent = products.length
        ? LABELS[correction] + ' lenses, ' + LABELS[state.answers.routine] + ', ranked for ' + LABELS[state.answers.priority] + '.'
        : loadFailed
          ? 'The live catalogue could not be loaded. Browse the full range or try again.'
          : 'Quality Eyes does not currently list an available product for this combination.';

      products.forEach(function (product, index) {
        ui.resultGrid.appendChild(createProductCard(product, index));
      });

      updateHeader('Your result', 100);
      updateNavigation();
      focusHeading(ui.resultTitle);
      emit('qe_quiz_result_view', {
        result_mode: 'guided',
        result_count: products.length,
        correction: correction || '',
        routine: state.answers.routine || '',
      });
    }

    function goBack() {
      if (state.view === 'result') {
        renderQuestion(QUESTIONS.length - 1);
        return;
      }
      if (state.view === 'guidance') {
        renderQuestion(state.answers.astigmatism === 'not-sure' ? 2 : 3);
        return;
      }
      if (state.view === 'question' && state.currentStep > 0) {
        renderQuestion(state.currentStep - 1);
      }
    }

    function closeQuiz() {
      if (dialog.open) dialog.close();
    }

    function openQuiz(initialFrequency) {
      reset();
      dialog.showModal();
      document.body.classList.add('overflow-hidden');

      if (initialFrequency) {
        state.answers.frequency = initialFrequency;
        emit('qe_quiz_start', { start_mode: 'teaser_answer', initial_frequency: initialFrequency });
        emit('qe_quiz_answer', { quiz_step: 1, answer_key: 'frequency', answer_value: initialFrequency });
        renderQuestion(1);
      } else {
        emit('qe_quiz_start', { start_mode: 'full_quiz' });
        renderQuestion(0);
      }

      loadProducts().catch(function () {
        // A visible fallback is rendered only when catalogue data is needed.
      });
    }

    root.querySelectorAll('[data-qe-quiz-open]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        openQuiz(trigger.dataset.qeQuizAnswer || '');
      });
    });

    ui.close.addEventListener('click', closeQuiz);
    ui.back.addEventListener('click', goBack);
    ui.restart.addEventListener('click', function () {
      reset();
      renderQuestion(0);
      emit('qe_quiz_restart');
    });

    ui.browseLinks.forEach(function (link) {
      link.addEventListener('click', function () {
        emit('qe_quiz_browse_all', { result_view: state.view });
      });
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeQuiz();
    });

    dialog.addEventListener('close', function () {
      document.body.classList.remove('overflow-hidden');
      emit('qe_quiz_close', { last_view: state.view, last_step: state.currentStep + 1 });
    });
  }

  function initAll(scope) {
    scope.querySelectorAll('[data-qe-quiz-root]').forEach(initQuiz);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
